/* Attrac's campaign copy is outside Shopify's translation resources.
 * Translate its text nodes using theme locale keys, preserving app controls. */
(() => {
  const config = document.getElementById('figini-popup-translations');
  if (!config) return;
  const translations = JSON.parse(config.textContent);
  const selector = '[id^="pop57814415_"]';
  const attached = new WeakSet();
  function translate(popup) {
    const walker = document.createTreeWalker(popup, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script,style')) continue;
      const original = node.textContent.trim();
      if (Object.hasOwn(translations, original)) {
        node.textContent = node.textContent.replace(original, translations[original]);
      }
    }
    popup.querySelectorAll('input[placeholder]').forEach(input => {
      const original = input.getAttribute('placeholder');
      if (Object.hasOwn(translations, original)) input.setAttribute('placeholder', translations[original]);
    });
  }
  function attach(popup) {
    if (attached.has(popup)) return;
    attached.add(popup);
    translate(popup);
    const observer = new MutationObserver(() => translate(popup));
    observer.observe(popup, {childList: true, characterData: true, subtree: true});
  }
  document.querySelectorAll(selector).forEach(attach);
  const loader = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      if (node.matches(selector)) attach(node);
      node.querySelectorAll(selector).forEach(attach);
    }
  });
  loader.observe(document.body, {childList: true, subtree: true});
})();
